export const referralTiers = [
  {
    id: 'guide',
    name: 'Guide',
    nameKey: 'guide',
    descriptionKey: 'guideDesc',
    agentsRequired: 10,
    reward: 100,
    weeklyBonus: 0,
    color: 'from-blue-500 to-blue-600',
    icon: 'ri-compass-3-line'
  },
  {
    id: 'dulce-expert',
    name: 'Dulce Expert',
    nameKey: 'dulceExpert',
    descriptionKey: 'dulceExpertDesc',
    agentsRequired: 90,
    reward: 1000,
    weeklyBonus: 0,
    color: 'from-purple-500 to-purple-600',
    icon: 'ri-star-line'
  },
  {
    id: 'premium-agents',
    name: 'Premium Agents',
    nameKey: 'premiumAgents',
    descriptionKey: 'premiumAgentsDesc',
    agentsRequired: 450,
    reward: 5000,
    weeklyBonus: 100,
    color: 'from-orange-500 to-red-500',
    icon: 'ri-vip-crown-line'
  },
  {
    id: 'grand-agent',
    name: 'Grand Agent',
    nameKey: 'grandAgent',
    descriptionKey: 'grandAgentDesc',
    agentsRequired: 1000,
    reward: 8000,
    weeklyBonus: 250,
    color: 'from-yellow-500 to-orange-500',
    icon: 'ri-trophy-line'
  }
];

export const mockReferrals = [
  {
    id: 1,
    name: 'María González',
    email: 'maria@example.com',
    joinDate: '2024-01-15',
    status: 'active',
    earnings: 150.00
  },
  {
    id: 2,
    name: 'Carlos Rodríguez',
    email: 'carlos@example.com',
    joinDate: '2024-01-12',
    status: 'active',
    earnings: 89.50
  },
  {
    id: 3,
    name: 'Ana López',
    email: 'ana@example.com',
    joinDate: '2024-01-10',
    status: 'inactive',
    earnings: 45.00
  },
  {
    id: 4,
    name: 'Luis Martínez',
    email: 'luis@example.com',
    joinDate: '2024-01-08',
    status: 'active',
    earnings: 200.75
  },
  {
    id: 5,
    name: 'Sofia Hernández',
    email: 'sofia@example.com',
    joinDate: '2024-01-05',
    status: 'active',
    earnings: 125.25
  }
];